import { AssignmentInd, Person } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { FC } from "react";
import { EPI_COLORS } from "./epiColors";
import './EpiEmployeeHeader.scss';

interface Props {
	name: string;
	registration?: string;
	position?: string;
	sector?: string;
	inspectionDate?: string;
	inspectionNumber?: string;
	avatarColor?: string;
}

const EpiEmployeeHeader: FC<Props> = ({ name, registration, position, sector, inspectionDate,
		inspectionNumber, avatarColor }) => (
	<div className="epi-employee-header">
		<div className="identidade">
			<span className="avatar" style={{ backgroundColor: avatarColor || EPI_COLORS.info }}>
				<Person fontSize="large" />
			</span>
			<div className="dados">
				<Typography variant="h6">{(name || '').toUpperCase()}</Typography>
				<div className="metadados">
					<span><strong>Matrícula: </strong>{registration || '—'}</span>
					<span><strong>Cargo: </strong>{position || '—'}</span>
					<span><strong>Setor: </strong>{sector || '—'}</span>
					{!!inspectionDate && (
						<span><strong>Data da inspeção: </strong>{inspectionDate}</span>
					)}
				</div>
			</div>
		</div>
		{!!inspectionNumber && (
			<div className="numero">
				<AssignmentInd />
				<div>
					<span>Inspeção nº</span>
					<Typography variant="h6">{inspectionNumber}</Typography>
				</div>
			</div>
		)}
	</div>
);

export default EpiEmployeeHeader;
